import { useEffect, useState } from 'react';
import config from '../../utils/apiUrl';
import formatMoney from '../../utils/formatMoney';

const useFetchCampaigns = ({company}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const columns = [
    {
      name: 'Nombre',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Fundación',
      selector: (row) => row.foundationName,
      sortable: true,
    },
    {
      name: 'Meta',
      selector: (row) => formatMoney(row.totalGoal),
      sortable: true,
    },
    {
      name: 'Estado',
      selector: (row) => row.companyAuth,
      sortable: true,
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${config.apiUrl}/company/admin/getCampaigns?company=${company}`
      );
      if (!response.ok) {
        throw new Error('Error en la solicitud: ' + response.statusText);
      }
      const result = await response.json();
      if (Array.isArray(result.programs)) {
        setData(result.programs);
      } else {
        setData([]);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return { columns, data, loading, error, refetch: fetchData };
};

export default useFetchCampaigns;
